import { SET_NOTIFICATION } from "@/store/mutations.type";
import { ROLE_ENUMS } from "@/common/constant.js";
import { cloneDeep, get, isEmpty, uniqBy } from "lodash";
import i18n from "@/plugins/i18n";

export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

export function onlyNumericV2(event) {
  let keyCode = event.which;
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    event.preventDefault();
  }
}

export function onlyNumeric(event) {
  let keyCode = event.which;
  if (keyCode < 48 || keyCode > 57) {
    event.preventDefault();
  }
}

export function onlyDecimal(event, value, maxlength) {
  let keyCode = event.which;
  if ((keyCode < 48 && keyCode !== 46) || keyCode > 57) {
    event.preventDefault();
    return;
  }
  if (value) {
    value += "";
    value = value.replace(/[^0-9\.]/g, "") + "";
    if (value.length > maxlength - 1) {
      event.preventDefault();
    }
  }
}

export function onlyInt(event) {
  const num = Number(event.key);
  if (!Number.isInteger(num) || num < 0) {
    event.preventDefault();
    return;
  }
}

export function formatNumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  if (!isNumeric(number)) {
    return number;
  }
  var value = Number(number);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function NumberWithCommas(number) {
  if (number === undefined || number == null) {
    return "";
  }
  try {
    var value = Number(number);
    var nf = new Intl.NumberFormat();
    return nf.format(value);
  } catch (error) {
    return number;
  }
}

export function toASCII(chars) {
  if (chars === undefined || chars === null || chars === "") {
    return chars;
  }
  chars = chars.replace("ー", "-");
  chars = chars.replace("。", ".");
  let ascii = "";
  for (let i = 0, l = chars.length; i < l; i++) {
    let c = chars[i].charCodeAt(0);
    if (c >= 0xff00 && c <= 0xffef) {
      c = 0xff & (c + 0x20);
    }
    ascii += String.fromCharCode(c);
  }
  ascii = ascii.replace("−", "-");
  return ascii;
}

export function splitAndJoinStr(v, regex, replaceValue) {
  v = v.toUpperCase();
  return v
    .replace(regex, replaceValue)
    .split(replaceValue)
    .filter((i) => i.trim().length !== 0)
    .join(replaceValue);
}
export function setCaretPosition(id, caretPos) {
  var elem = document.getElementById(id);
  if (elem != null) {
    if (elem.createTextRange) {
      var range = elem.createTextRange();
      range.move("character", caretPos);
      range.select();
    } else {
      if (elem.selectionStart) {
        elem.focus();
        elem.setSelectionRange(caretPos, caretPos);
      } else elem.focus();
    }
  }
}

export function getCurrentLocalDate() {
  return getLocalDate(0);
}

export function getStartLocalDate() {
  return getLocalDate(-1);
}

export function getLocalDate(days) {
  let date = new Date();
  if (-1 === days) {
    date.setDate(1);
  } else {
    date.setDate(date.getDate() - days);
  }
  date = new Date(date - new Date().getTimezoneOffset() * 60000);
  return date.toISOString().substr(0, 10);
}

export function getRoleNameById(roleId) {
  let result = ROLE_ENUMS.find((r) => r.roleId === roleId);
  if (result === null || result === undefined) {
    return "";
  }
  return result.roleName;
}

export function getRoleEnumById(roleId) {
  let result = ROLE_ENUMS.find((r) => r.roleId === roleId);
  if (result === null || result === undefined) {
    return "";
  }
  return result;
}

const ALERT =
  (color) =>
  ({ message, timeout = 3000 }) => {
    vm.$store.commit(SET_NOTIFICATION, {
      color,
      message,
      timeout,
    });
  };
export const alertError = ALERT("error");
export const alertSuccess = ALERT("success");
export const alertWarning = ALERT("#FFA000");

//lodash
export const cloneObject = (object) => cloneDeep(object);
export const getPathObject = (object, suffix) => {
  if (!object) {
    return null;
  }
  return get(object, suffix);
};
export const isNal = (value) => !value || value === 0;
export const isEmptyObj = (value) => isEmpty(value);

//RULES
export const RULES = {
  required(v, fieldName) {
    return !!v || v === 0 || i18n.t("msg.required", [fieldName]);
  },
  requiredNumber(v, fieldName) {
    return !!v || v === 0 || i18n.t("msg.requiredNumber", [fieldName]);
  },
  maxLength(v, fieldName, MAX_LENGTH) {
    return (
      (v || "").length <= MAX_LENGTH ||
      i18n.t("msg.maxLength", [fieldName, MAX_LENGTH])
    );
  },
  onlyNumber: (v, fieldName) => {
    if (v) {
      return isNumeric(v) || i18n.t("msg.onlyNumber", [fieldName]);
    }
    return true;
  },

  onlyNumberAndDiffZero: (v, fieldName) => {
    if (parseInt(v) === 0) {
      return i18n.t("msg.onlyNumber", [fieldName]);
    }
    if (v) {
      return isNumeric(v) || i18n.t("msg.onlyNumber", [fieldName]);
    }
    return true;
  },
  valueInputBetween(v, fieldName, min, max) {
    if (v || v === 0) {
      return (
        (v >= min && v <= Number(max)) ||
        i18n.t("msg.valueInputBetween", [fieldName, min, max])
      );
    }
    return true;
  },
  negativeNumber: (v, fieldName) => {
    if (!!v) {
      return (
        (isNumeric(v) && parseInt(v) > 0) ||
        i18n.t("msg.requirePositiveNumber", [fieldName])
      );
    }
    return true;
  },
  positiveNumberWithOneAfterDecimal(v, fieldName) {
    if (!v || (v && v.length <= 0)) {
      return true;
    }
    const regex = new RegExp("^d*[0-9]+(?:.[0-9]*)?$");
    return (
      (regex.test(v) && parseFloat(v) <= 999999999) ||
      i18n.t("msg.invalidInputValue", [fieldName])
    );
  },
  isPositiveNumberWithOneAfterDecimal(v) {
    if (!v || (v && v.length <= 0)) {
      return false;
    }
    const regex = new RegExp("^d*[0-9]+(?:.[0-9]*)?$");
    return regex.test(v) && parseFloat(v) <= 999999999;
  },
  fileSize: (v, fieldName, maxSize) => {
    if (v) {
      return (
        !v ||
        v.size <= maxSize * 1024 * 1024 ||
        i18n.t("msg.fileSize", [fieldName, maxSize])
      );
    }
    return true;
  },
  validateOfficeFile: (v, fieldName) => {
    if (!v) {
      return true;
    }
    let array = v.name.split(".");
    let extension = array[array.length - 1];
    if (!OFFICE_FILE_EXTENSIONS.includes(extension)) {
      return "有効なファイルタイプを更新してください。";
    }
    return true;
  },
};

export function isBackSpaceOrDeleteAction(eventCode) {
  return ["Backspace", "Delete"].includes(eventCode);
}

export function generateUrlWithQueries(url, object) {
  let propertyNames = Object.getOwnPropertyNames({ ...object })
    .filter(
      (propertyName) => object[propertyName] === 0 || object[propertyName],
    )
    .sort();
  let returnUrl = propertyNames.filter((name) => "return_url" === name);
  propertyNames = propertyNames.filter((name) => "return_url" !== name);
  if (propertyNames && propertyNames.length > 0) {
    url = url + "?";
    propertyNames.forEach((propertyName, index) => {
      let propertyValue = object[propertyName];
      if (propertyValue === 0 || propertyValue) {
        url = url + `${propertyName}=${propertyValue}`;
        if (index < propertyNames.length - 1) {
          url += "&";
        }
      }
    });
  }
  if (returnUrl.length > 0) {
    url += `&return_url=${encodeURIComponent(object["return_url"])}`;
  }
  return url;
}

export function generateQueries(object) {
  const propertyNames = Object.getOwnPropertyNames({ ...object })
    .filter(
      (propertyName) => object[propertyName] === 0 || object[propertyName],
    )
    .sort();
  let result = {};
  if (propertyNames && propertyNames.length > 0) {
    propertyNames.forEach((propertyName) => {
      let propertyValue = object[propertyName];
      if (propertyValue === 0 || propertyValue) {
        result[propertyName] = propertyValue;
      }
    });
  }
  return result;
}

export function formatYearMonth(yearMonth) {
  if (yearMonth) {
    const [year, month] = yearMonth.split("-");
    return `${year}年${month}月`;
  }
}

export function formatValueText(value, text, onlyText = false) {
  if (value !== null && !onlyText) {
    return `${value} - ${text}`;
  }
  return `${text}`;
}

export function formatValueToText(value, text) {
  if (value !== null) {
    return `${value} - ${text}`;
  } else {
    return "";
  }
}

export function calcPercent(total, current, fixed = 2) {
  if (total === 0) return (0).toFixed(fixed);
  if (isNaN(total) || isNaN(current)) return (0).toFixed(fixed);
  return parseFloat((current / total) * 100).toFixed(fixed);
}

export function mappingFilterItems(list, keyCode, keyText) {
  if (!list || list.length === 0) return [];
  let items = list.filter((item) => !!item[keyCode]);
  items = items.map((item) => ({
    value: item[keyCode],
    text: item[keyText],
  }));
  return uniqBy(items, (item) => item.value);
}

export function pageInformation(PAGINATION) {
  return `${PAGINATION.pageStart + 1} - ${PAGINATION.pageStop} の ${
    PAGINATION.itemsLength
  }`;
}

export function hasPermission(permissions, roles) {
  if (!permissions) return false;
  const roleCodes = roles.map((role) => role.roleCode);
  const even = (role) => roleCodes.includes(role);
  return permissions.some(even);
}

export function parsePermissionId(permissionId) {
  return permissionId < 100 ? `0${permissionId}` : permissionId;
}
export function showMonth(timeline) {
  if (!timeline) {
    return "";
  }
  const [year, month] = timeline.split("-");
  return `${parseInt(month)}月`;
}
export function showYearMonth(timeline) {
  if (!timeline) {
    return "";
  }
  const [year, month] = timeline.split("-");
  return `${year}年${parseInt(month)}月`;
}

export function downloadFile(data, headers) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  const contentDisposition = headers["content-disposition"];
  let nameFromAttachment = contentDisposition.split(
    `attachment; filename*=UTF-8''`,
  )[1];
  const fileName = decodeURIComponent(nameFromAttachment.replace(/\+/g, " "));
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export const OFFICE_FILE_EXTENSIONS = [
  "xlsx",
  "XLSX",
  "doc",
  "DOC",
  "pptx",
  "PPTX",
  "XLS",
  "xls",
  "DOCX",
  "docx",
  "jpg",
  "JPG",
  "jpeg",
  "JPEG",
  "png",
  "PNG",
];

export function downloadFileByUrl(url, fileName) {
  const link = document.createElement("a");
  link.href = url;
  if (fileName) link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
